import React, { useState } from 'react';
import Select from 'react-select';
// import { handleOnFocusById } from '../../common/utils/CommonUtils';

export default function CustomSelect(props) {

    const [data, setData] = useState(null);

    const customStyles = {
        container: (base) => ({
            ...base,
            height: '100%',
            minWidth: '142px',
        }),
        control: (base, state) => ({
            ...base,
            height: '100%',
            minHeight: props.controlHeight || '40px',
            border: state.isFocused ? 0 : 0,
            boxShadow: state.isFocused ? 0 : 0,
            '&:hover': {
                border: state.isFocused ? 0 : 0
            },
            borderRadius: '8px',
            backgroundColor: props.backgroundColor || '#1A1A1A',
        }),
        placeholder: (base) => ({
            ...base,
            fontSize: '16px',
            // padding: '2px 16px'
            // color: '#00173D'
        }),
        menu: (base) => ({
            ...base,
            marginTop: '5px',
            marginBottom: '0px',
            backgroundColor: '#333333',
            zIndex: 2000,
            "&:hover": {
                borderColor: "red"
            }
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '2px 16px'
        }),
        option: (base, state) => ({
            ...base,
            padding: '17px',
            fontSize: '16px',
            "&:hover": {
                backgroundColor: "#8d1df9"
            },
            backgroundColor: state.isSelected ? '#6d1df0' : '',

        }),
        singleValue: (base) => ({
            ...base,
            fontSize: props.valueFontSize || '18px',
            color: '#FFFFFF',
            height: '18px',
            fontSize: props.baseFontSize || '18px',
        }),
        input: (base) => ({
            ...base,
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '16px',
            color: '#FFFFFF;'
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#6D1DF0',
                color: '#FFFFFF'
            };
        },

        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: data.color,
            fontSize: '70%'
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: 'red',
            ':hover': {
                backgroundColor: '#db4254',
                color: 'white',
            },
        }),
    }

    const handleChange = (item) => {
        setData(item);

        props.handleChange(item);
    }

    return (
        <Select
            id={props.id}
            className={props.className || 'custom-select'}
            value={props.hasOwnProperty('value') ? props.value : data}
            onChange={handleChange}
            onInputChange={props.onInputChange}
            isClearable={props.hasOwnProperty('isClearable') ? props.isClearable : true}
            options={props.options || []}
            getOptionValue={(option) => option['label'] || option.name}
            getOptionLabel={(option) => option['label'] || option.name}
            placeholder={props.placeholder}
            styles={customStyles}
            isMulti={props.isMulti || false}
            isDisabled={props.isDisabled}
            // menuIsOpen={true}
            components={{
                IndicatorSeparator: () => null
            }}
            onFocus={() => {
                // handleOnFocusById(`${props.id || props.placeholder}`)
            }}
        />
    )
}


// behavior Optional
// Defines the transition animation. One of auto or smooth. Defaults to auto.

// block Optional
// Defines vertical alignment. One of start, center, end, or nearest. Defaults to start.

// inline Optional
// Defines horizontal alignment. One of start, center, end, or nearest. Defaults to nearest.